import VTootipBtn from './VTootipBtn.vue'

export { VTootipBtn }
export default VTootipBtn
